import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import vars from '@/config/vars';
import enableMocking from '@/services/mocks';
import consoleConfig from '@/services/console';
import initSentry from '@/services/sentry';
import './assets/styles/global.css';
import App from './App';

// eslint-disable-next-line
console.log(`%cApp version: ${__VERSION__} (${vars.env})`, 'color:green');

// Initialize Sentry only for PPD builds
if (vars.sentry.dsn) {
  initSentry(vars.sentry.dsn, vars.env);
}

consoleConfig.start(vars.console);

enableMocking().then(() => {
  createRoot(document.getElementById('root')).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
